export default "__VITE_ASSET__DEM4uoEn__"